module.exports = __webpack_public_path__ + "img/idCode1.3980b3d7.png";